// "A new version is available": the one thing a deploy cannot tell an already-open tab.
// Ported from Facility Navigator (apps/web/src/components/NewVersionNudge.tsx), 2026-10-14.
// See lib/appVersion.js for how a new build is detected.

import React, { useState } from 'react';
import { useNewVersionAvailable } from '../lib/appVersion';

/**
 * NEVER RELOADS ON ITS OWN. A reload throws away whatever the tab is in the middle of (a half-
 * filled pay app, a schedule edit, an upload), so the person decides, and the copy tells them to
 * finish first.
 *
 * Fixed bottom-right so it never pushes page content around. z-index sits below Summit's modals
 * (10000+): a dialog someone opened on purpose outranks a housekeeping nudge. It sits above the
 * Job Costs sync chip (900), which only shows for 5 seconds.
 */
const NewVersionNudge = () => {
  const stale = useNewVersionAvailable();
  const [dismissed, setDismissed] = useState(false);
  if (!stale || dismissed) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        position: 'fixed', right: 20, bottom: 20, zIndex: 1200,
        display: 'flex', alignItems: 'center', gap: 12,
        maxWidth: 380, padding: '11px 13px',
        background: 'var(--bg-surface)', color: 'var(--text-1)',
        border: '1px solid var(--border-strong)', borderRadius: 10,
        boxShadow: '0 8px 24px rgba(0,0,0,.18)', fontSize: 13,
      }}
    >
      <span style={{ lineHeight: 1.45 }}>
        A new version is available.
        <span style={{ color: 'var(--text-3)' }}> Reload when you've finished what you're working on.</span>
      </span>
      <button
        type="button"
        onClick={() => window.location.reload()}
        style={{
          flex: 'none', padding: '6px 12px', borderRadius: 7, cursor: 'pointer',
          border: '1px solid var(--border-strong)', background: 'var(--bg-hover)',
          color: 'var(--text-1)', fontSize: 12.5, fontWeight: 600,
        }}
      >
        Reload
      </button>
      <button
        type="button"
        onClick={() => setDismissed(true)}
        aria-label="Dismiss"
        title="Dismiss"
        style={{
          flex: 'none', width: 24, height: 24, lineHeight: '22px', borderRadius: 6, cursor: 'pointer',
          border: '1px solid transparent', background: 'transparent', color: 'var(--text-3)', fontSize: 15,
        }}
      >
        ×
      </button>
    </div>
  );
};

export default NewVersionNudge;
